<template>
  <div class="parent">
    <div class="box">
      <BInputPullDown
        label-name="类型"
        v-model="searchParam.taskTypeId"
        :Options="testPaperTypeList"
        placeholder="全部"
      />
      <BInputDateRange
        v-model="createTime"
        from-text="创建时间"
        to-text="至"
        @startDateChange="startDateChange"
        @endDateChange="endDateChange"
      />
      <BInputText
        label-text="关键字"
        v-model="searchParam.createName"
        placeholder="作业名/创建人"
      />
    </div>
    <div class="box">
      <BInputPullDown
        label-name="状态"
        v-model="searchParam.status"
        :Options="statusList"
        placeholder="全部"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
          <BBtnDropDown
              btn-txt="添加作业"
              :img-src="require('@/assets/new.png')"
              :dropdown-data="this.dropdownData"
              v-if="editFlag == 'false'"
              :clicked="onClickedDropDown" 
              style="margin: 5px;"/>
            <BBtnPrimary
            :img-src="require('@/assets/professional.png')"
            :clicked="handleBank"
            btn-txt="作业库"
          />
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="homeworkList"
        :length="totalPages"
        :total-visible="7"
        :page-num="pageNum"
        v-model="pageNum"
        :enableFloating="Boolean(tipShow)"
        :hiddenKey="unReadNum"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="handleEdit(item.data.id)">
              编辑
            </div>
            <div class="btn-delete" @click="handleDelete(item.data)">
              删除
            </div>
            <div class="btn-detail" @mouseenter="mouseEnter(item.data.unReadNum)" @mouseleave="tipShow = false" @click="handleTestPagerRead(item.data.id)">
              批阅
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchList, searchInit, testdelete } from "@/api/testPaperRelease";
import BInputPullDown from "../../components2/BInputPullDown";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputDateRange from "../../components2/BInputDateRange";
import Hub from "../../events/Hub";
import PopupContents from "../../views2/sample/PopupContents";
import BBtnDropDown from "../../components2/BBtnDropDown";
import Vue from "vue";
export default {
  name: "CourseHomework",
  components: {
    Table,
    BInputText,
    BInputPullDown,
    BBtnSecondary,
    BBtnPrimary,
    BInputDateRange,
    BBtnDropDown,
  },
  data: () => ({
    tipShow: false,
    editFlag:sessionStorage.getItem("editFlag").toString(),
    deleteDialog: false,
    totalPages: 0,
    pageNum: 1,
    pageCount: 10,
    totalCount: 0,
    dropdownData: [
      {name: "理论作业"},
      {name: "实操作业"},
    ],
    searchParam: {},
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center", width: '3%' },
      { text: "作业名", value: "testPaperName", sortable: false, align: "center", width: '12%' },
      { text: "作业类型", value: "testPaperType", sortable: false, align: "center", width: '6%' },
      { text: "生效班级", value: "trainClassName", sortable: false, align: "center", width: '12%' },
      { text: "生效时间", value: "validTime", sortable: false, align: "center", width: '10%' },
      { text: "章节", value: "trainLessonName", sortable: false, align: "center", width: '10%' },
      { text: "状态", value: "statusName", sortable: false, align: "center", width: '6%' },
      { text: "完成量", value: "completeNum", sortable: false, align: "center", width: '6%' },
      { text: "创建人", value: "createUserName", sortable: false,align: "center", width: '8%' },
      { text: "创建时间", value: "createTime", sortable: false, align: "center", width: '10%' },
      { text: "操作", value: "actions", sortable: false, align: "center"},
    ],
    homeworkList: [],
    testPaperTypeList: [],
    statusList: [],
    id: 0,
    createTime: {
      from: "",
      to: "",
    },
    data: {},
    data_courseId:"",
    // 状态
    status:'',
    unReadNum: 0,
    navi: [
      {name: "course-management"},
      {name: "course_homework-release"},
    ],
  }),
  props: ["courseId"],
  created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
  },
  mounted() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
    this.data_courseId = this.$props.courseId;

    this.doSearch(true);
    this.searchInit();
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  methods: {
    mouseEnter (e) {
      this.tipShow = true
      this.unReadNum = e
    },
    set(value) {
      console.info(value);
      if (value === 1) {
        // 成功 页面刷新
        this.deleteTest();
      }
    },
    // 编辑
    handleEdit(id) {
      var obj = {
        flag: "homeworkReleaseAdd",
        paperId: "",
        paperReleaseId: id,
      };
      this.$emit("openFlag", obj);
    },
    // 初始化
    async searchInit() {
      const data = await searchInit();
      this.testPaperTypeList = data.data.testPaperTypeList;
      this.statusList = data.data.statusList;
    },
    // 点击查询
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.pageNum = 1;
        this.pageCount = 10;
        this.totalCount = 0;
      } else {
        // 查询条件赋值
        if (this.$store.state.courseManagement_TaskTypeId !== undefined) {
          this.searchParam.taskTypeId = this.$store.state.courseManagement_TaskTypeId;
        }
        if (this.$store.state.courseManagement_status !== undefined) {
          this.searchParam.status = this.$store.state.courseManagement_status;
        }
        if (this.$store.state.courseManagement_startDate !== undefined) {
          this.searchParam.startDate = this.$store.state.courseManagement_startDate;
        }
        if (this.$store.state.courseManagement_endDate !== undefined) {
          this.searchParam.endDate = this.$store.state.courseManagement_endDate;
        }
        if (this.$store.state.courseManagement_createName !== undefined) {
          this.searchParam.createName = this.$store.state.courseManagement_createName;
        }
      }
      this.searchList(this.searchParam);
    },
    // 查询page列表
    async searchList(searchParam) {
      var param = {
        page: this.pageNum,
        limit: this.pageCount,
        taskTypeId: searchParam.taskTypeId,
        subjectType: "01",
        status: searchParam.status,
        startDate: this.createTime.from,
        endDate: this.createTime.to,
        createName: this.comUtils.trim(searchParam.createName),
        bbxTrainCourseId: this.data_courseId,
      };
      // 把查询条件存入缓存
      this.$store.commit("SET_TEST_MANAGEMENT_PARAMS", param);
      const data = await searchList(param);
      if (data.data.searchList != null || data.data.searchList === "") {
        this.homeworkList = data.data.searchList;
      }
      this.totalCount = data.data.totalCount;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
    },
    // 新增作业
    onClickedDropDown(name) {
      if("实操作业" === name) {
        let routeData = this.$router.resolve({name: 'course_homework-bank-practice-add', query: { courseId: this.data_courseId }});
        window.open(routeData.href, '_blank');
      }
      if("理论作业" === name) {
        let routeData = this.$router.resolve({name: 'course_homework-bank-theory-add', query: { courseId: this.data_courseId }});
        window.open(routeData.href, '_blank');
      }
    },
    // 作业库
    handleBank() {
      var obj = {
        flag: "homeworkBank",
      };
      this.$emit("openFlag", obj);
    },
    // 批阅
    handleTestPagerRead(id) {
      var obj = {
        testPaperReleaseId: id,
        flag: "homeworkReview",
      }
      this.$emit('openFlag',obj)
    },
    // 点击删除
    handleDelete(data) {
      this.id = data.id;
      this.status = data.status;
      if (data.status === "01") {
        this.data.bodyText = "确认删除该考试？";
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
      } else {
        this.data.bodyText = "将同步删除学员端的考试记录，确认删除？";
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
      }
    },
    async deleteTest() {
      var param = {
        id: this.id,
        status:this.status,
      };
      const data = await testdelete(param);

      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.doSearch(true);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    startDateChange(value) {
      this.createTime.from = value;
    },
    endDateChange(value) {
      this.createTime.to = value;
    },
  },
};
</script>

<style scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
 /*top: 0;*/
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
  align-items: center;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
  .parent {
    margin-top: 1.5em;
  }
</style>
